import { TemplateState } from './template-state.model';

export const INITIAL_TEMPLATE_STATE: TemplateState = {
  templates: [],
  templatesCachedAt: null,
  loadTemplatesError: null,
  folderCreationError: null,
  createdFolderId: null,
};
